import { Box } from '@monorepo/nova-ui';
import { styled } from '@mui/material/styles';

export const StyledImageContainer = styled(Box)(({ theme }) => ({
  width: '100%',
  height: '100vh',
  backgroundSize: 'cover',
  backgroundPosition: 'center',
  backgroundRepeat: 'no-repeat',
  flex: '0 0 50%',
  [theme.breakpoints.down('md')]: {
    flexBasis: '100%',
    height: theme.spacing(53),
    flex: '0 0 auto',
  },
}));
